import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import AboutSection from './components/AboutSection';
import AdditionalServicesSection from './components/AdditionalServicesSection';
import ReviewsSection from './components/ReviewsSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';
import EstimateModal from './components/EstimateModal';

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <Navbar onEstimateClick={() => setModalOpen(true)} />
      <main>
        <HeroSection onEstimateClick={() => setModalOpen(true)} />
        <ServicesSection />
        <AboutSection />
        <AdditionalServicesSection />
        <ReviewsSection />
        <CTASection onEstimateClick={() => setModalOpen(true)} />
      </main>
      <FooterSection />
      <EstimateModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
